export enum PosIntegrationType {
  Simphony = '0',
  FRS = '1',
  RTS = '2'
}

export const availableIntegrations = Object.keys(PosIntegrationType)
  .filter(key => isNaN(Number(key)))
  .map(key => ({ key: PosIntegrationType[key as keyof typeof PosIntegrationType], value: key }));